module.exports = __webpack_public_path__ + "img/ic_dl.32749214.svg";